export default "__VITE_ASSET__BWhR4a2q__"